import type { CSSProperties } from 'react';
import { cn } from '@/lib/cn';

const sizes = { xs: 'size-3.5 border-[1.5px]', sm: 'size-4 border-2', md: 'size-5 border-2', lg: 'size-8 border-[3px]' };

/** Індикатор завантаження (успадковує колір тексту для дуги). */
export function Spinner({ size = 'sm', className, label }: { size?: keyof typeof sizes; className?: string; label?: string }) {
  return (
    <span
      role={label ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      className={cn('inline-block shrink-0 animate-spin rounded-full border-current border-r-transparent opacity-80', sizes[size], className)}
    />
  );
}

/** Блок-заглушка під час завантаження. */
export function Skeleton({ className, style }: { className?: string; style?: CSSProperties }) {
  return <span aria-hidden className={cn('skeleton block h-4 w-full', className)} style={style} />;
}

/** Кілька рядків-заглушок тексту. */
export function SkeletonText({ lines = 3, className }: { lines?: number; className?: string }) {
  return (
    <div className={cn('flex flex-col gap-2', className)} aria-hidden>
      {Array.from({ length: lines }, (_, i) => (
        <Skeleton key={i} className={i === lines - 1 ? 'w-2/3' : 'w-full'} />
      ))}
    </div>
  );
}

/** Центрований лоадер у блоці сторінки. */
export function LoadingBlock({ label = 'Завантаження…', className }: { label?: string; className?: string }) {
  return (
    <div className={cn('flex items-center justify-center gap-3 py-12 text-sm text-muted', className)} role="status" aria-live="polite">
      <Spinner size="sm" className="text-primary" />
      {label}
    </div>
  );
}
